import { render } from "./EditTaskNote.vue?vue&type=template&id=68b0dc19"
import script from "./EditTaskNote.vue?vue&type=script&lang=js"
export * from "./EditTaskNote.vue?vue&type=script&lang=js"

import "./EditTaskNote.vue?vue&type=style&index=0&id=68b0dc19&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__